import { defineAsyncComponent } from 'vue'
export default {
  "ai-chat": defineAsyncComponent(() => import("/var/www/mj_client/releases/20261105063928/layouts/ai-chat.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/var/www/mj_client/releases/20261105063928/layouts/default.vue").then(m => m.default || m)),
  simple: defineAsyncComponent(() => import("/var/www/mj_client/releases/20261105063928/layouts/simple.vue").then(m => m.default || m))
}